export default __webpack_public_path__ + "static/image5-7833125211d0b6148f1baa35aa7183c2.jpg";